import { Link as RouterLink, useLocation } from 'react-router-dom';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {
  Box,
  Button,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import logo from '../../assets/logo.png';

const drawerWidth = 240;

function Sidebar({ companyInfo, sidebarLinks, quickInfo, open, onClose, whatsappPath }) {
  const { pathname } = useLocation();

  const drawerContent = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 2.5 }}>
        <Stack direction="row" spacing={1.25} alignItems="center">
          <Box
            component="img"
            src={logo}
            alt={`${companyInfo.name} logo`}
            sx={{
              width: 52,
              height: 42,
              objectFit: 'contain',
              borderRadius: 1.5,
              bgcolor: '#ffffff',
              border: '1px solid rgba(201,168,76,0.26)',
            }}
          />
          <Box>
            <Typography sx={{ color: '#ffffff', fontWeight: 900, lineHeight: 1.05, fontSize: '0.92rem' }}>
              {companyInfo.name}
            </Typography>
            <Typography sx={{ color: '#c9a84c', fontSize: '0.68rem', letterSpacing: 1.5, textTransform: 'uppercase' }}>
              {companyInfo.tagline}
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Divider sx={{ borderColor: '#c9a84c', opacity: 0.5 }} />

      <List sx={{ px: 1.25, py: 1.5 }}>
        {sidebarLinks.map((link) => {
          const Icon = link.icon;
          const active = link.path === '/' ? pathname === link.path : pathname.startsWith(link.path);

          return (
            <ListItemButton
              key={link.path}
              component={RouterLink}
              to={link.path}
              onClick={onClose}
              sx={{
                mb: 0.5,
                borderLeft: active ? '3px solid #c9a84c' : '3px solid transparent',
                bgcolor: active ? 'rgba(201,168,76,0.15)' : 'transparent',
                color: active ? '#c9a84c' : 'rgba(255,255,255,0.78)',
                borderRadius: 2,
              }}
            >
              <ListItemIcon sx={{ color: active ? '#c9a84c' : 'rgba(255,255,255,0.5)', minWidth: 38 }}>
                <Icon />
              </ListItemIcon>
              <ListItemText primary={link.label} />
            </ListItemButton>
          );
        })}
      </List>

      <Box sx={{ mt: 'auto', p: 2.5 }}>
        <Typography sx={{ color: '#c9a84c', fontWeight: 800, mb: 1.2 }}>Quick Contact</Typography>
        <Stack spacing={0.7} sx={{ mb: 2 }}>
          {quickInfo.map((item) => (
            <Typography key={item.label} sx={{ color: 'rgba(255,255,255,0.76)', fontSize: '0.92rem' }}>
              {item.value}
            </Typography>
          ))}
        </Stack>
        <Button
          component="a"
          href={whatsappPath}
          target="_blank"
          rel="noreferrer"
          startIcon={<WhatsAppIcon />}
          fullWidth
          variant="contained"
          color="primary"
        >
          {companyInfo.sidebarCtaLabel}
        </Button>
      </Box>
    </Box>
  );

  return (
    <Drawer
      variant="temporary"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      PaperProps={{
        sx: {
          width: drawerWidth,
          borderRight: '1px solid rgba(201,168,76,0.18)',
          top: 64,
          height: 'calc(100% - 64px)',
        },
      }}
    >
      {drawerContent}
    </Drawer>
  );
}

export default Sidebar;
